/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, useState,useEffect ,useContext} from 'react';
import { IPickerModel } from '@rhybus/api'
import { AuthContext } from './AuthContextProvider'
// import{ rhybusRListsHttp } from '../../api/rhybus-list-http'

interface UserContextProviderProps {
  children: React.ReactNode;
}

// Initialize context with the default value
const UserInitalValue = 
{ 
     me: null as any    
};

const UserContext = createContext(UserInitalValue);

const UserContextProvider: React.FC<UserContextProviderProps> = ({ children }) => {
    const [me, _setMe] = useState<IPickerModel>()
    const authContext = useContext(AuthContext)
    useEffect(() => {
        if(authContext?.accessToken)
            {
                // doStart()
            }           
    }
    , [authContext?.accessToken])

    // async function doStart() {
    //     const meValue:any = await rhybusRListsHttp().me()
    //     console.log(meValue);
    //     setMe(meValue)
    // }
  
  return (
    <UserContext.Provider value={{me }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext,UserContextProvider,  UserInitalValue }